import React, { useState, useEffect } from "react";
import { createFilePath } from "@/common";
import { useWatchState } from "@/store";
import { Form, Input, Icon, Button } from "antd";
import { uploadUrl } from "@/service";
import { FileList, Upload } from "@/components";
import { isNullObject } from "@/check";

const { TextArea } = Input;

interface ProjectOrgProps {
    form: any,
    onSubmit: Function,
    loading: boolean,
    defaultData: any
}

const App = Form.create({ name: '' })(({ form, onSubmit, loading, defaultData = {} }: ProjectOrgProps) => {
    const { getFieldDecorator } = form;

    const [[UPLOAD_SERVER_HOST = ""]] = useWatchState(["$_UPLOAD_SERVER_HOST"]);

    const [files, setFiles] = useState<any>([]);
    const [defaultDate, setDefaultDate] = useState<any>([]);

    useEffect(() => {
        if (!isNullObject(defaultData) && defaultData.files) {
            setFiles(defaultData.files);
            setDefaultDate(defaultData);
        }
    }, [defaultData])

    const handleSubmit = (e: any) => {
        e.preventDefault();
        form.validateFieldsAndScroll(async (err: any, values: any) => {
            if (!err) {
                onSubmit(values, files);
            }
        });
    };

    const onUploadFileFinish = (e: any) => {
        setFiles([...files, ...e.file.response.files.map(({ fileShowName, url }: any) => ({ name: fileShowName, url }))])
    }
    const onRemoveFile = (e: any) => {
     //   console.log(e);
    }

    return (
        <Form id="feedForm" className="com-feedback__form" onSubmit={handleSubmit}>
            <Form.Item label="项目单位名称">
                {getFieldDecorator('name', {
                    initialValue: defaultData.name,
                    rules: [
                        {
                            required: true,
                            message: '请输入项目单位名称！',
                        },
                    ],
                })(<Input placeholder="请输入项目单位名称"  defaultValue={defaultData.name}/>)}
            </Form.Item>
            <Form.Item label="所在省市">
                {getFieldDecorator('province_name', {
                    initialValue: defaultData.province_name,
                    rules: [
                        {
                            required: true,
                            message: '请输入所在省市！',
                        },
                    ],
                })(<Input placeholder="请输入所在省市" />)}
            </Form.Item>
            <Form.Item label="反馈意见">
                {getFieldDecorator('remark', {
                    initialValue: defaultData.remark,
                    rules: [
                        {
                            required: true,
                            message: '请输入反馈意见！',
                        },
                    ],
                })(<TextArea rows={3} placeholder="请输入反馈意见" />)}
            </Form.Item>
            <Form.Item label="附件">
                <FileList data={files.map((o: any) => ({ ...o, url: createFilePath(o.url, UPLOAD_SERVER_HOST) }))} onRemove={onRemoveFile} />
                <Upload
                    name="files"
                    className="full"
                    onFinish={onUploadFileFinish}
                    action={uploadUrl}
                    showUploadList={false}>
                    <button className="com-feedback__file-btn" type="button"><Icon type="plus" /></button>
                </Upload>
            </Form.Item>

            <Form.Item>
                <Button type="primary" htmlType="submit" loading={loading}>
                    保存
                </Button>
            </Form.Item>
        </Form>
    )
})

export default App;